export const ROUTE_COLORS = [
  "#2e7be7", // blue (matches existing active default)
  "#8e44ad", // purple
  "#16a085", // teal
  "#d35400", // orange
  "#c0392b", // red
  "#f1c40f", // yellow
  "#27ae60", // green
];

export const colorForIndex = (idx = 0) =>
  ROUTE_COLORS[Math.abs(idx) % ROUTE_COLORS.length] || ROUTE_COLORS[0];
